import { render, staticRenderFns } from "./SharingStatusIcon.vue?vue&type=template&id=40e28c19&scoped=true&"
import script from "./SharingStatusIcon.vue?vue&type=script&lang=js&"
export * from "./SharingStatusIcon.vue?vue&type=script&lang=js&"
import style0 from "./SharingStatusIcon.vue?vue&type=style&index=0&id=40e28c19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e28c19",
  null
  
)

export default component.exports